import { render, staticRenderFns } from "./RiseupGoalUpdatedToaster.vue?vue&type=template&id=331b9e22&scoped=true"
import script from "./RiseupGoalUpdatedToaster.vue?vue&type=script&lang=js"
export * from "./RiseupGoalUpdatedToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b9e22",
  null
  
)

export default component.exports